import React from "react";
import {
  INDUSTRIES,
  RESOURCES,
  COMPLIMENTARYSERVICES,
  AudioVisual,
  Services,
  Company,
} from "components/layout/footer/FooterData";
import LogoSvg from "assets/svg/logo";
import { Link } from "gatsby";
import OptimizedImage from "hooks/OptimizedImage";

export default function FooterNavigation() {
  return (
    <>
      <footer>
        <div className="pt-24  bg-basecol text-gray px-10 md:pl-10 xl:pl-0">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 lg:place-content-center md:p-0 sm:p-7">
              <div className="font-opensans mb-10 lg:mb-0 md:mb-0 md:mr-10">
                <div className="flex pb-12 items-center">
                  <a href="https://www.tomedes.com/">
                    <LogoSvg />
                  </a>
                </div>
                <div className="flex items-center justify-center flex-col">
                  <h3 className="text-sm font-opensans font-normal leading-[28px] text-footertext">
                    Tomedes Translation Services is committed to broadening the
                    horizons of individuals and businesses in the United States
                    and internationally, through the effective use of
                    professional translation services.{" "}
                  </h3>
                  <h3 className="text-sm font-opensans font-normal leading-[28px] mt-8 text-footertext">
                    Our translation company provides fast and accurate
                    translation services in more than 120 languages and 950+
                    language pairs and is available 24/7 via email, phone or
                    chat.
                  </h3>
                </div>
              </div>
              {/* <div className="md:mb-20 mb-10 lg:mb-24 md:flex flex-col md:items-center">
                <h2 className="font-secondary pb-10 text-lg font-semibold text-white uppercase">
                  Industries
                </h2>
                <ul className="font-opensans text-sm cursor-pointer md:pl-3">
                  {INDUSTRIES?.map(({ data, link }, index) => (
                    <li
                      key={index}
                      className=" hover:text-hover text-footertext font-opensans pb-2 leading-[30px]"
                    >
                      <Link to={link}>{data}</Link>
                    </li>
                  ))}
                </ul>
              </div> */}
              {/* <div className="mb-10 lg:mb-24 md:pl-7 ml-0 lg:ml-16">
                <div className="font-secondary pb-10 lg:pb-6 text-lg font-semibold text-white uppercase ">
                  Audio-visual
                  <br />
                  translation
                </div>
                <ul className="font-opensans text-sm cursor-pointer">
                  {AudioVisual?.map(({ data, link }, index) => (
                    <li
                      key={index}
                      className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                    >
                      <Link to={link}>{data}</Link>
                    </li>
                  ))}
                </ul>
              </div> */}
              <div className="flex gap-5 mb-10 md:hidden">
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_9001.webp" alt="ISO9001" className="w-20 sm:w-28 h-auto" />
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_17100.webp" alt="ISO17100" className="w-20 sm:w-28 h-auto" />
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_18587.webp" alt="ISO18587" className="w-20 sm:w-28 h-auto" />
              </div>
               <div className="mb-10 lg:mb-24 md:pl-7 xl:ml-7">
                <div className="font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                  SERVICES
                </div>
                <ul className="font-opensans text-sm cursor-pointer">
                  {Services?.map(({ data, link }, index) => (
                    <li
                      key={index}
                      className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                    >
                      <Link to={link}>{data}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mb-10 lg:mb-24 md:pl-7">
                <div className="font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                  RESOURCES
                </div>
                <ul className="font-opensans text-sm cursor-pointer">
                  {RESOURCES?.map(({ data, link }, index) => (
                    <li
                      key={index}
                      className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                    >
                      <Link to={link}>{data}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mb-10 lg:mb-24 lg:pl-7 md:mt-10 lg:mt-0">
                <div className="font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                  COMPANY
                </div>
                <ul className="font-opensans text-sm cursor-pointer">
                  {Company?.map(({ data, link }, index) => (
                    <li
                      key={index}
                      className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                    >
                      <Link to={link}>{data}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* <div className="mb-10 lg:mb-24">
                <h2 className="font-secondary pb-10 text-lg font-semibold text-white uppercase">COMPLIMENTARY SERVICES</h2>
                <ul className="font-opensans text-sm cursor-pointer">
                  {COMPLIMENTARYSERVICES?.map(({ link }, index) => (
                    <li key={index} className=" text-footertext pb-2 hover:text-hover font-opensans leading-[30px]">
                      {link}
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
